<script>
export default {
  name: 'Price',
  props: {
    moeda: {
      type: String,
      default: 'R$'
    },
    valor: {
      type: String,
      default: '00,00'
    },
    intervalo: {
      type: String,
      default: 'por mês'
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    reais () {
      return this.valor.split(',')[0]
    },
    centavos () {
      return `,${this.valor.split(',')[1]}`
    },
    styles () {
      return {
        container: {
          '--scale': this.scale
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="container"
    :style="styles.container"
  >
    <div class="left">
      {{ moeda }}
    </div>
    <div class="center">
      {{ reais }}
    </div>
    <div class="right">
      <div class="top">
        {{ centavos }}
      </div>
      <div class="bottom">
        {{ intervalo }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  .left {
    font-size: calc(27px * var(--scale));
    line-height: calc(27px * var(--scale));
    font-weight: 100;
  }
  .center {
    font-size: calc(73px * var(--scale));
    line-height: calc(73px * var(--scale));
    font-weight: 700;
  }
  .right {
    .top {
      font-size: calc(26px * var(--scale));
      line-height: calc(26px * var(--scale));
    }
    .bottom {
      font-size: calc(13px * var(--scale));
      line-height: calc(13px * var(--scale));
      margin-left: calc(5px * var(--scale));
      font-weight: 100;
      opacity: 0.7;
    }
  }
}
</style>
